/* @flow */

import React from 'react';

import Alert from '@material-ui/lab/Alert';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';

import ButtonComponent from 'components/buttons/button';
import FormErrorsComponent from 'components/formErrors';
import IntlMessageComponent from 'components/formatters/intlMessage';
import MandatoryFormFieldsComponent from 'components/form/mandatory';
import PageSubTitleViewComponent from 'components/pageTitle/subTitle';
import SecurityComponent from 'components/security/index';

import ContactPersonFormComponent from './contactPersonForm';
import ContactPersonListComponent from './contactPersonList';

import CompanyContactPerson from 'models/companies/companyContactPerson';
import SupplierCompany from 'models/confirming/supplierCompany';

type ConfirmingAddSupplierTabContactComponentViewProps = {
  selectedContactPerson: CompanyContactPerson;
  contactPersons: CompanyContactPerson[];
  supplierCompany: SupplierCompany;
  displayForm: boolean;
  formErrors: string[];
  isProcessing: boolean;
  skipStep: () => void;
  handleContactCreated: () => void;
  selectContact: (contactPersonId: number) => void;
  submitForm: () => void;
  toggleContactForm: () => void;
  unSelectContact: (contactPersonId: number) => void;
}

export default function ConfirmingAddSupplierTabContactViewComponent(props: ConfirmingAddSupplierTabContactComponentViewProps) {
  return (
    <React.Fragment>
      <FormErrorsComponent formErrors={props.formErrors} />

      <PageSubTitleViewComponent
        id="page.confirming.tabcontact.selectContact.title"
        values={{ debtorname: props.supplierCompany.name }}
      />

      <Alert severity="info">
        <IntlMessageComponent id="page.confirming.tabcontact.info" />
      </Alert>
      <Box mt={5}>
        <Grid container direction="row" justify="flex-start" alignItems="flex-start" spacing={1}>
          <Grid item xs={12} md={6}>
            {props.contactPersons.length > 0 ? (
              <Box px={4}>
                <ContactPersonListComponent
                  selectedContactPerson={props.selectedContactPerson}
                  contactPersons={props.contactPersons}
                  selectHandler={props.selectContact}
                  unselectHandler={props.unSelectContact}
                />
              </Box>
            ) : (
              <Box m={5}>
                <IntlMessageComponent id="page.confirming.tabcontact.noContacts" />
              </Box>
            )}
          </Grid>

          <Grid item xs={12} md={6}>
            {props.displayForm ? (
              <ContactPersonFormComponent
                activeCompanyId={props.activeCompanyId}
                supplierId={props.supplierCompany.supplierId}
                successHandler={props.handleContactCreated}
                cancelHandler={props.toggleContactForm}
              />
            ) : (
              <Box mt={3} textAlign="center">
                <ButtonComponent
                  color="primary"
                  variant="contained"
                  disabled={props.isProcessing}
                  onClick={props.toggleContactForm}
                ><IntlMessageComponent id="page.sellInvoice.tab3.addNewContact.button" /></ButtonComponent>
              </Box>
            )}
          </Grid>
        </Grid>
      </Box>

      <Box mt={5}>
        <ButtonComponent
          color="default"
          variant="contained"
          disabled={props.isProcessing}
          onClick={props.skipStep}
        ><IntlMessageComponent id="page.confirming.button.skipstep" /></ButtonComponent>

        <Box component="span" ml={1}>
          <ButtonComponent
            color="primary"
            variant="contained"
            disabled={props.contactPersons == null || props.contactPersons.length === 0}
            isProcessing={props.isProcessing}
            onClick={props.submitForm}
          ><IntlMessageComponent id="page.confirming.tabcontact.button.validate" /></ButtonComponent>
        </Box>

      </Box>
    </React.Fragment>
  );
}